import { SuppliesInventoryConfigStatusSchema } from "@redotech/redo-fulfillment-common/supplies";
import { suppliesInventoryConfigIdFormat } from "@redotech/redo-marketplace-id";
import { SuppliesTrackableProductTypeSchema } from "@redotech/redo-supplies-common/trackable-product";
import { SortDirection } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const SuppliesInventoryConfigRowSchema_ = z.object({
  id: suppliesInventoryConfigIdFormat.schema,
  productTitle: z.string(),
  productSku: z.string().nullable(),
  productImageUrl: z.string().nullable(),
  status: SuppliesInventoryConfigStatusSchema,
  inventoryReorderThreshold: z.number(),
  suppliesReorderQuantity: z.number(),
  unitsPerCase: z.number().nullable(),
  locationName: z.string(),
  availableInventory: z.number(),
  // Catalog default unless the config overrides it; null if untracked.
  leadTimeDays: z.number().nullable(),
  // Set only when the merchant has overridden the catalog default.
  leadTimeDaysOverride: z.number().nullable(),
  // Drives the parcel-vs-label-paper change-history table. Null if untracked.
  trackableType: SuppliesTrackableProductTypeSchema.nullable(),
  // Timestamp of the most recent placed reorder; null if none yet.
  lastOrderDate: z.date().nullable(),
});

export const SuppliesInventoryConfigRowSchema: z.ZodType<SuppliesInventoryConfigRow> =
  SuppliesInventoryConfigRowSchema_;
export interface SuppliesInventoryConfigRow extends z.infer<
  typeof SuppliesInventoryConfigRowSchema_
> {}

export const getSuppliesInventoryConfigs = {
  name: "getSuppliesInventoryConfigs" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
  }),
  output: z.object({ configs: z.array(SuppliesInventoryConfigRowSchema) }),
};

export const getSuppliesInventoryConfigsCount = {
  name: "getSuppliesInventoryConfigsCount" as const,
  input: z.object({}),
  output: z.object({ total: z.number() }),
};
